/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCustomDomainValidResponse
 */
export interface ControlCustomDomainValidResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomDomainValidResponse
     */
    valid: boolean;
}

/**
 * Check if a given object implements the ControlCustomDomainValidResponse interface.
 */
export function instanceOfControlCustomDomainValidResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "valid" in value;

    return isInstance;
}

export function ControlCustomDomainValidResponseFromJSON(json: any): ControlCustomDomainValidResponse {
    return ControlCustomDomainValidResponseFromJSONTyped(json, false);
}

export function ControlCustomDomainValidResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCustomDomainValidResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valid': json['valid'],
    };
}

export function ControlCustomDomainValidResponseToJSON(value?: ControlCustomDomainValidResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valid': value.valid,
    };
}

